module.exports = __webpack_public_path__ + "static/media/ic-clock-massage.e6ff7a3b.svg";